export default {"src":"/_next/static/media/medal-solid.1ff22922.svg","height":24,"width":24};